module.exports = __webpack_public_path__ + "static/IMG-8-d750f933c26e2935f557d4c18608175e.jpg";